module.exports = __webpack_public_path__ + "img/11.a21691b3.webp";